/**
 * Será usado como um hook, porém é uma classe para inscrever-se/notificar eventos
 * entre componentes.
 */
class EventBus {
  constructor() {
    this._listeners = {};  
  }
  
  notify(eventType, data) {
    if (Array.isArray(this._listeners[eventType])) {
      this._listeners[eventType].forEach((callback) => callback(data));
    }
  }

  /**
   * 
   * @param {string} eventType Identificador do evento inscrito 
   * @param {Function} listener Callback que será disparada quando o evento for notificado 
   * @param {boolean} resetable Indicada se o evento é realocável, ou seja, se for ré-inscrito, ele armazenará
   * apenas o ultimo listener inscrito. 
   */
  subscribe(eventType, listener, resetable = true) {
    if (!this._listeners[eventType]) {
      this._listeners[eventType] = [];
    }
    if (resetable && this._listeners[eventType].length) {
      this._listeners[eventType].length = 0;
    }
    this._listeners[eventType].push(listener);
  }
}

const globalEventBus = new EventBus();

export function useEventBus() {
  return globalEventBus;
}